import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@thos/Widgets/MyPartNumbers/SearchTextField";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.pages.orderHistory.getOrdersParameter,
    };
};

export const searchTextFieldStyles: SearchTextFieldStyles = {
    wrapper: {
        css: css`
            padding: 10px;
            width 100%;
        `,
    },
};
const styles = searchTextFieldStyles;

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const MyPartNumbersSearchField: React.FC<Props> = props => {
    return (
        <SearchTextField
            styles={styles}
            label={translate("My Part Number")}
            parameterField="customerPartNumber"
            placeholder={translate("My Part Number")}
            inputType="text"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyPartNumbersSearchField),
    definition: {
        group: "My Part Numbers" as any,
        displayName: "My Part Number Search",
        allowedContexts: ["MyPartNumbersPage" as any],
    },
};

export default widgetModule;
